import { Component, OnInit, Input } from '@angular/core';
import {
  ProgramTypesGUID,
  PaymentScheduleTabName
} from '../../../models/_enum-collections';
import { PaymentBatchTableComponent } from '../../shared/payment-batch-table/payment-batch-table.component';

@Component({
  selector: 'app-csi-payment-schedule-milestone2',
  templateUrl: './csi-payment-schedule-milestone2.component.html',
  styleUrls: ['./csi-payment-schedule-milestone2.component.scss'],
  standalone: true,
  imports: [PaymentBatchTableComponent]
})
export class CsiPaymentScheduleMilestone2Component implements OnInit {
  @Input() program: ProgramTypesGUID | null = null;
  tabName!: PaymentScheduleTabName;

  ngOnInit(): void {
    this.tabName = PaymentScheduleTabName.Milestone2;
  }
}
